import { ActionContext } from "vuex";
import { Module, VuexModule, Mutation, getModule } from "vuex-module-decorators";
import { store } from "@/loader";
import { BvToast, BvToastOptions } from "bootstrap-vue";

@Module({
	name: "toaster",
	store,
	dynamic: true,
	namespaced: true,
})
export class ToasterModule extends VuexModule {
	public bvToast!: BvToast;
	public defaultOptions: BvToastOptions = {
		solid: true,
		toaster: "b-toaster-top-center",
	};
	public noAutoHideVariant: string[] = ["danger"];

	@Mutation
	public setToaster(toaster: BvToast) {
		this.bvToast = toaster;
	}

	@Mutation
	public setDefaultOptions(payload: BvToastOptions) {
		this.defaultOptions = payload;
	}

	@Mutation
	public toast(payload: BvToastOptions & { message: string }) {
		if (payload.noAutoHide === undefined && payload.variant) {
			payload.noAutoHide = this.noAutoHideVariant.includes(payload.variant);
		}
		this.bvToast.toast(payload.message, {
			...this.defaultOptions,
			...payload
		});
	}
}

export const toaster = getModule(ToasterModule, store);

export function commitToasterToast(context: ActionContext<any, any>, payload: BvToastOptions & { message: string }) {
	context.commit("toaster/toast", payload, { root: true });
}
